// Bulk tracking-legs modal strings (auto-merged by lib/i18n.ts).
export const en = {
  'operator.bulk_legs.title': 'Bulk edit tracking legs',
  'operator.bulk_legs.hint':
    'Add, reorder, or remove every leg of this shipment at once. Saving replaces the full itinerary.',
}

export const zhTW = {
  'operator.bulk_legs.title': '批次編輯追蹤航段',
  'operator.bulk_legs.hint': '一次新增、調整或移除此貨件的所有航段。儲存後將取代整段行程。',
}
